import { AlgoliaSearch } from "@/services/algoliaSearch"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

/**
 * Retrieves articles based on the provided arguments.
 *
 * @param {Object} parent - The parent object.
 * @param {Object} args - The arguments object.
 * @param {Object} context - The context object.
 * @param {Object} info - The info object.
 * @returns {Object} - The articles and related information.
 */
export const queryArticleQuerySuggestions = {
  async articleQuerySuggestions(parent, args, context, info) {
    const { searchTerm } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ARTICLES,
      operation: Operations.READ,
    })

    if (!searchTerm || searchTerm.length < 4) {
      throw new Error("Search term to short!")
    }

    const algoliaClient = AlgoliaSearch.client()

    const articleQuerySuggestions = await algoliaClient.searchSingleIndex({
      indexName: "articles_query_suggestions",
      searchParams: {
        query: searchTerm,
        hitsPerPage: 3,
        filters: `popularity>3`,
      },
    })

    if (articleQuerySuggestions?.hits?.length === 0) {
      return null
    }

    return {
      suggestions: articleQuerySuggestions.hits
        .map((hit) => hit?.query || null)
        .filter((query) => query && query !== searchTerm),
    }
  },
}
